/**
 * Insights Service — "DataBunker Insights": reportes HTML que el equipo interno publica
 * desde el portal (Reports › HTML). Back: routes/insights.py.
 *
 *   listInsightsReports(username)     -> metadata de los reportes publicados del usuario
 *   getInsightsReport(id, username)   -> el reporte con su html_content (para el <iframe>)
 *
 * El backend toma el usuario del token de Cognito (lo agrega utils/authFetch.js); el
 * username de la URL solo se compara contra él. Mismo patrón de request() que
 * visualsBuilderService.js.
 */

const API_URL = process.env.REACT_APP_STRANDS_API_URL || 'http://localhost:5001';

const qs = (params) => {
  const usp = new URLSearchParams();
  Object.entries(params || {}).forEach(([k, v]) => {
    if (v !== undefined && v !== null && v !== '') usp.set(k, v);
  });
  const s = usp.toString();
  return s ? `?${s}` : '';
};

async function request(path) {
  const res = await fetch(`${API_URL}${path}`, {
    method: 'GET',
    headers: { 'Content-Type': 'application/json' },
  });
  let data = null;
  try { data = await res.json(); } catch { /* respuesta vacía o no-JSON */ }

  if (!res.ok) {
    const msg = (data && (data.error || data.message)) || `HTTP ${res.status}`;
    const err = new Error(msg);
    err.status = res.status;
    err.payload = data;
    throw err;
  }
  return data;
}

export const listInsightsReports = (username) =>
  request(`/api/insights/reports${qs({ username })}`);

export const getInsightsReport = (reportId, username) =>
  request(`/api/insights/reports/${reportId}${qs({ username })}`);

const insightsService = { listInsightsReports, getInsightsReport };

export default insightsService;
